/* -------------------------------------------------------------------------- */
/*                                  Packages                                  */
/* -------------------------------------------------------------------------- */
import { BackgroundImage } from "@abmg-components"
import { graphql, useStaticQuery } from "gatsby"
import { GatsbyImage } from "gatsby-plugin-image"
import * as React from "react"

/* -------------------------------------------------------------------------- */
/*                              Default Function                              */
/* -------------------------------------------------------------------------- */
export default function Hero() {
  const data = useStaticQuery(graphql`
    query {
      HeroForegroundDesktop: file(
        relativePath: { regex: "/referral/hero-foreground-desktop/" }
      ) {
        childImageSharp {
          gatsbyImageData
        }
      }
      HeroForegroundMobile: file(
        relativePath: { regex: "/referral/hero-foreground-mobile.png/" }
      ) {
        childImageSharp {
          gatsbyImageData(height: 267, width: 335, layout: FIXED)
        }
      }
      HeroBackgroundBlue: file(
        relativePath: { regex: "/referral/hero-background-blue/" }
      ) {
        childImageSharp {
          gatsbyImageData
        }
      }
      HeroBackgroundTexture: file(
        relativePath: { regex: "/referral/hero-background-texture/" }
      ) {
        childImageSharp {
          gatsbyImageData(layout: FULL_WIDTH)
        }
      }
    }
  `)
  return (
    <div className="h-[415px] relative">
      <BackgroundImage
        backgroundImage={
          data.HeroBackgroundBlue.childImageSharp.gatsbyImageData
        }
      />

      {/* Main Container */}
      <div className="grid grid-cols-1 grid-rows-1 h-full justify-items-center max-w-[1152px] mx-auto min-desktop4:grid-cols-[auto_auto]">
        <h1 className="col-start-1 col-end-2 justify-self-center leading-[29px] text-center max-w-full mt-[168px] row-start-1 row-end-2 w-[267px] z-[10] min-tablet1:leading-[42px] min-tablet1:w-[385px] min-desktop4:justify-self-start min-desktop4:leading-[49px] min-desktop4:mt-[92px] min-desktop4:w-[451px]">
          <span className="font-variant-numeric--primary font-[800] font-['akagi-pro'] leading-[29px] text-[32px] text-arctic-blue-1 text-center uppercase min-tablet1:leading-[42px] min-tablet1:text-[46px] min-desktop4:leading-[49px] min-desktop4:text-[54px]">
            Start building
          </span>
          <span className="font-variant-numeric--primary bg-white flex flex-col font-[400] font-['mascot-mvb'] h-[53px] items-center justify-center leading-[29px] [padding-inline:10px] text-[60px] text-arctic-blue text-center min-tablet1:h-[76px] min-tablet1:leading-[42px] min-tablet1:text-[86px] min-desktop4:h-[89px] min-desktop4:leading-[49px] min-desktop4:text-[101px]">
            your future
          </span>{" "}
          <span className="font-variant-numeric--primary font-[800] font-['akagi-pro'] leading-[29px] text-[32px] text-arctic-blue-1 text-center uppercase min-tablet1:leading-[42px] min-tablet1:text-[38px] min-desktop4:leading-[49px] min-desktop4:text-[44px]">
            One step at a time
          </span>
        </h1>
        <GatsbyImage
          alt="a mom, dad with moving boxes, and a child"
          className="col-start-1 col-end-2 mt-[51px] row-start-1 row-end-2 min-tablet1:!hidden"
          image={data.HeroForegroundMobile.childImageSharp.gatsbyImageData}
        />
        <GatsbyImage
          alt="a mom, dad with moving boxes, and a child"
          className="col-start-1 col-end-2 row-start-1 row-end-2 hidden min-tablet1:!block min-desktop4:col-start-2 min-desktop4:col-end-3"
          image={data.HeroForegroundDesktop.childImageSharp.gatsbyImageData}
        />
      </div>
      <div className="absolute bottom-0 h-[179px] w-full z-[20]">
        <BackgroundImage
          backgroundImage={
            data.HeroBackgroundTexture.childImageSharp.gatsbyImageData
          }
        />
      </div>
    </div>
  )
}
